"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ssrWindow = require("ssr-window");

var _dom = _interopRequireDefault(require("@spothero/utils/dom"));

var ModalContent =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ModalContent, _Component);

  function ModalContent(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ModalContent);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ModalContent).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onWindowResize", function (evt) {
      var _this$props = _this.props,
          maxHeight = _this$props.maxHeight,
          contentAreaHeight = _this$props.contentAreaHeight,
          verticalModalPadding = _this$props.verticalModalPadding;
      var windowWidth = _ssrWindow.window.innerWidth || _ssrWindow.document.body.clientWidth;
      var calculatedMax = maxHeight;

      if ((0, _isString.default)(calculatedMax) && calculatedMax === 'auto') {
        var modalWrapperEl = _dom.default.parent(_this._container, '.Modal-wrapper');

        var titleEl = modalWrapperEl.querySelector('.Modal-title');
        var finalContentAreaHeight = (0, _isUndefined.default)(contentAreaHeight) ? _dom.default.height(modalWrapperEl, true, false) - _dom.default.height(titleEl) : (0, _isFunction.default)(contentAreaHeight) ? contentAreaHeight() : contentAreaHeight;
        calculatedMax = windowWidth < 768 ? finalContentAreaHeight : finalContentAreaHeight - verticalModalPadding - 24; // 24 is margin-bottom
      }

      _this._container.style.maxHeight = "".concat(calculatedMax, "px");
    });
    var children = props.children,
        html = props.html;

    if (children && html) {
      throw new Error('Passing children or html props is exclusive. You may only use one at a time.');
    }

    return _this;
  }

  (0, _createClass2.default)(ModalContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      _ssrWindow.window.addEventListener('resize', this._onWindowResize);

      this._resizeTimeout = _ssrWindow.window.setTimeout(function () {
        _this2._onWindowResize();
      }, 0);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _ssrWindow.window.clearTimeout(this._resizeTimeout);

      _ssrWindow.window.removeEventListener('resize', this._onWindowResize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          noPadding = _this$props2.noPadding,
          contentAreaHeight = _this$props2.contentAreaHeight,
          children = _this$props2.children,
          html = _this$props2.html;
      var content = html ? _react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: html
        }
      }) : children;
      var classes = (0, _classnames.default)('Modal-content', {
        'Modal-content-flush': noPadding
      }, {
        'Modal-content-with-height': !(0, _isUndefined.default)(contentAreaHeight)
      }, className);
      return _react.default.createElement("div", {
        ref: function ref(node) {
          _this3._container = node;
        },
        className: classes
      }, _react.default.createElement("div", {
        className: "Modal-content-wrapper"
      }, content));
    }
  }]);
  return ModalContent;
}(_react.Component);

exports.default = ModalContent;
(0, _defineProperty2.default)(ModalContent, "defaultProps", {
  maxHeight: 'auto',
  verticalModalPadding: 32
});